import { generateApiPath } from "@routes/generatePath";

const pathBase = `/reports/images/`;

export const images = {
  get: () => generateApiPath(pathBase),
};
